import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import TextEditor from 'flarum/common/components/TextEditor';
import MarkButton from './components/MarkButton';
app.initializers.add('ppk2-format', () => {
  // Right after the Markdown toolbar (priority 100), so the highlighter sits next to its buttons.
  extend(TextEditor.prototype, 'toolbarItems', function (items) {
    const editor = this.attrs.composer && this.attrs.composer.editor;
    items.add('ppk2-mark', m(MarkButton, {
      editor: editor
    }), 90);
  });
});